import { put, takeLatest } from "redux-saga/effects";
import {
  getAllUserInvitationsFailure,
  getAllUserInvitationsRequest,
  getAllUserInvitationsSuccess,
  createUserInvitationFailure,
  createUserInvitationRequest,
  createUserInvitationSuccess,
  deleteUserInvitationFailure,
  deleteUserInvitationRequest,
  deleteUserInvitationSuccess,
  resendUserInvitationFailure,
  resendUserInvitationRequest,
  resendUserInvitationSuccess
} from "../features/organizations/users";
import { httpDelete, httpGet, httpPost } from "../../services";

function* getAllUserInvitationsSaga(action) {
  const { orgId } = action.payload;
  try {
    const response = yield httpGet("/organization/invitations", { id: orgId });
    if (response.ErrorCode) {
      throw new Error(response.Message || response.Description || response.ErrorMessage);
    }
    yield put(getAllUserInvitationsSuccess(response));
  } catch (error) {
    yield put(getAllUserInvitationsFailure(error.message));
  }
}

function* resendUserInvitationSaga(action) {
  try {
    const response = yield httpPost("/organization/invitation/resend", {}, { invitationId: action.payload });
    if (response.ErrorCode) {
      throw new Error(response.Message || response.Description || response.ErrorMessage);
    }
    yield put(resendUserInvitationSuccess(response));
  } catch (error) {
    yield put(resendUserInvitationFailure(error.message));
  }
}

function* deleteUserInvitationSaga(action) {
  try {
    const response = yield httpDelete("/organization/invitation", { id: action.payload });
    if (response.ErrorCode) {
      throw new Error(response.Message || response.Description || response.ErrorMessage);
    }
    yield put(deleteUserInvitationSuccess(response));
  } catch (error) {
    yield put(deleteUserInvitationFailure(error.message));
  }
}

function* createUserInvitationSaga(action) {
  try {
    const response = yield httpPost("/organization/invitation", {}, action.payload);
    if (response.ErrorCode) {
      throw new Error(response.Description || response.ErrorMessage);
    }
    yield put(createUserInvitationSuccess(response));
  } catch (error) {
    yield put(createUserInvitationFailure(error.message));
  }
}

export default function* watchInvitationsSaga() {
  yield takeLatest(getAllUserInvitationsRequest.type, getAllUserInvitationsSaga);
  yield takeLatest(resendUserInvitationRequest.type, resendUserInvitationSaga);
  yield takeLatest(deleteUserInvitationRequest.type, deleteUserInvitationSaga);
  yield takeLatest(createUserInvitationRequest.type, createUserInvitationSaga);
}
